import { render, staticRenderFns } from "./SignFail.vue?vue&type=template&id=6c0f3e54"
import script from "./SignFail.vue?vue&type=script&lang=js"
export * from "./SignFail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports